import angular from 'angular';
import regulatorFormComponent from './regulator-edit-form.component';

export default angular.module('components.app.dashboard.regulator-edit-form', [])
  .component('regulatorEditForm', regulatorFormComponent)
  .name;



// WEBPACK FOOTER //
// ./components/app/admin/regulator/regulator-edit-form/regulator-edit-form.module.js